import axios from "./http.js";
class EmailApi {
  static sendEmail() {
    const abortController = new AbortController();
    return {
      async call(data) {
        return axios.post(`/v1/Email/send`, data, {
          signal: abortController.signal
        });
      },
      cancel() {
        abortController == null ? void 0 : abortController.abort();
      }
    };
  }
}
var stdin_default = EmailApi;
export {
  stdin_default as default
};
